import styles from "./external.module.css"

export default function External({title, subTitle, link}){
    return(
        <a  href={`https://${link}`} target="_blank">
            <div className={styles.item}>
                <span className={`uppercase ${styles.initial}`}>{title}</span>
                <span className={`narrow-light ${styles.initial}`}>{subTitle}</span>
                <span className={`uppercase white ${styles.hovered}`}>{link}</span>
            </div>
        </a>
    )

}